var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "search-result__tile global-material-tile" },
    [
      _c(
        "a",
        {
          staticClass: "tile--link",
          attrs: { href: _vm.result.href },
          on: { click: _vm.openLink },
        },
        [
          _c("img", {
            staticClass: "tile--image img-responsive",
            attrs: {
              title: _vm.result.title,
              src: _vm.result.image_src,
              alt: _vm.result.alt,
            },
            on: { load: _vm.onImageLoaded },
          }),
          _vm._v(" "),
          _c("p", { staticClass: "tile--title" }, [
            _c("b", [_vm._v(_vm._s(_vm.result.title))]),
            _vm._v(" " + _vm._s(_vm.result.titleSuffix)),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "tile--subtitle" }, [
            _vm._v(_vm._s(_vm.result.subtitle)),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }